import React, { useState } from 'react';
import clsx from 'clsx';
import undoIcon from '@/assets/images/svg/undo.svg';

interface ConfiguredBadgeProps {
  onUndo: () => void;
}

export const ConfiguredBadge: React.FC<ConfiguredBadgeProps> = ({ onUndo }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div className='absolute right-0 top-[13px] flex items-center gap-2 pr-6'>
      {/* Badge */}
      <div
        className={clsx('flex items-center justify-center', 'rounded-16 bg-purple-600 px-3 py-1')}
      >
        {/* Strict font tokens: text-11 + leading-105 */}
        <span className='font-sans text-11 font-normal leading-105 tracking-normal text-white'>
          CONFIGURED
        </span>
      </div>

      {/* Undo Button */}
      <div className='relative'>
        <button
          type='button'
          onClick={(e) => {
            e.stopPropagation();
            onUndo();
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className={clsx(
            'flex size-6 items-center justify-center rounded-5 transition-colors',
            'hover:bg-gray-335'
          )}
          aria-label='Undo'
        >
          <img src={undoIcon} alt='Undo' className='size-full object-contain' draggable={false} />
        </button>

        {/* Tooltip */}
        {isHovered && (
          <div
            className={clsx(
              'absolute left-1/2 top-full mt-1 -translate-x-1/2',
              'rounded-5 bg-black-70 px-2 py-1',
              'z-50 whitespace-nowrap'
            )}
          >
            <span className='font-sans text-11 font-normal leading-105 tracking-normal text-white'>
              REVERT
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
